import type { CSSProperties } from "react";

// A search toggle while it is on: the globe and the research sources beside it light up alike, in the
// unchanged signal colour. Colour is never the only cue: the globe's stroke gets heavier and a source's
// word turns semibold, so the tint needs no contrast and the label keeps the text rule.
export const ACCENT_PRESSED: CSSProperties = {
  color: "var(--context-accent)",
  backgroundColor: "color-mix(in srgb, var(--color-accent) 14%, transparent)",
};
